class LanguageForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[name="locale_code"]');
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}
customElements.define('language-form', LanguageForm);

addEventListener("DOMContentLoaded", (event) => {
  const allLinks = document.querySelectorAll('a');

  if (allLinks.length > 0) {
    allLinks.forEach(link => {
      const href = link.getAttribute('href');

      if (href && (!href.includes('carryboo.ch') || !href.includes('carryboo.myshopify.com')) && href.includes('http')) {
        link.setAttribute('target', '_blank');
      }
    });
  }
});